module.exports = __webpack_public_path__ + "1aefb52ad95486f52ac14c2f891975ab.MP3";